var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "f7-views",
        [
          _c(
            "f7-view",
            {
              key: _vm.connected,
              attrs: {
                domCache: false,
                uniqueHistory: false,
                id: "main-view",
                main: "",
                url: _vm.url,
              },
            },
            [
              _c("left-panel", {
                attrs: { stats: _vm.stats, isSidebarOpen: _vm.isSidebarOpen },
                on: {
                  "update:isSidebarOpen": function ($event) {
                    _vm.isSidebarOpen = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("header-panel", {
                attrs: { isSidebarOpen: _vm.isSidebarOpen },
              }),
              _vm._v(" "),
              !_vm.minimize
                ? _c(
                    "div",
                    {
                      class: [
                        "card-auto",
                        {
                          yellow: _vm.isPaused && !_vm.isLoading,
                          blue: _vm.isLoading && !_vm.isPaused,
                          green: !_vm.isPaused && !_vm.isLoading,
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "px-6 py-4",
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                gap: "0.5rem",
                              },
                            },
                            [
                              _c("span", [_vm._v("🤖")]),
                              _vm._v(" "),
                              _c("div", {
                                style: {
                                  "border-radius": "50%",
                                  "background-color": _vm.isPaused
                                    ? "#f0b100"
                                    : !_vm.isLoading
                                    ? "#00c951"
                                    : "oklch(62.3% 0.214 259.815)",
                                  height: "0.6rem",
                                  width: "0.6rem",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "Auto-match: " +
                                    _vm._s(
                                      _vm.isPaused
                                        ? "Paused"
                                        : !_vm.isLoading
                                        ? "Active"
                                        : "Syncing"
                                    )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.minimize = !_vm.minimize
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-solid fa-down-left-and-up-right-to-center",
                                }),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.isLoading && !_vm.isPaused
                        ? _c(
                            "div",
                            {
                              staticClass: "px-6 py-2",
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "border-top": "1px solid #ebe6e7",
                                "border-bottom": "1px solid #ebe6e7",
                                "background-color": "#ffffff4d",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    gap: "0.5rem",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa-light fa-clock" }),
                                  _c("span", [_vm._v("Next Check:")]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.display))]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "px-6 pt-3" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "0.5rem",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-regular fa-circle-check",
                                }),
                                _c("span", [_vm._v("Matches Today:")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.stats.NbReconciliation)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "0.5rem",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-regular fa-arrow-trend-up",
                                }),
                                _c("span", [_vm._v("Volume today:")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "€" +
                                  _vm._s(
                                    _vm.stats.AmountReconciliation.toFixed(2)
                                  )
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("hr"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "px-6 pb-3",
                          staticStyle: {
                            display: "grid",
                            "grid-template-columns": "1fr 1fr",
                            gap: "0.5rem",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              staticStyle: {
                                border: "1px solid #0000001a",
                                color: "black",
                                "background-color": "#fff",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.isPaused = !_vm.isPaused
                                },
                              },
                            },
                            [
                              _c("i", {
                                class: [
                                  "fa-regular",
                                  {
                                    "fa-pause": !_vm.isPaused,
                                    "fa-play": _vm.isPaused,
                                  },
                                ],
                              }),
                              _vm._v(
                                " " + _vm._s(_vm.isPaused ? "Start" : "Pause")
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-dark",
                              on: { click: _vm.runReconciliation },
                            },
                            [
                              _c("i", { staticClass: "fa-regular fa-bolt" }),
                              _vm._v(
                                _vm._s(_vm.isLoading ? "Running..." : "Run now")
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      class: [
                        "card-min p-6",
                        {
                          yellow: _vm.isPaused && !_vm.isLoading,
                          blue: _vm.isLoading && !_vm.isPaused,
                          green: !_vm.isPaused && !_vm.isLoading,
                        },
                      ],
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "0.5rem",
                      },
                      on: {
                        click: function ($event) {
                          _vm.minimize = !_vm.minimize
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("🤖")]),
                      _vm._v(" "),
                      _c("div", {
                        style: {
                          "border-radius": "50%",
                          "background-color": _vm.isPaused
                            ? "#f0b100"
                            : !_vm.isLoading
                            ? "#00c951"
                            : "oklch(62.3% 0.214 259.815)",
                          height: "0.6rem",
                          width: "0.6rem",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.isLoading && !_vm.isPaused
                        ? _c("span", [_vm._v(_vm._s(_vm.display))])
                        : _vm._e(),
                    ]
                  ),
              _vm._v(" "),
              _c("f7-pages", {
                class: [
                  "content bg-light" +
                    (!_vm.connected ? "marginHomepageLargeScreen" : ""),
                  { expanded: _vm.isSidebarOpen },
                ],
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("cm-popups"),
      _vm._v(" "),
      _c("notifications-rtp", {
        staticStyle: { top: "80px", "z-index": "10070" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }